import React from 'react';
import { Modal } from 'antd';
import { useTranslation } from 'react-i18next';
import { ModalFooter } from '~/components/Modal';
import { RedTimes, TableView } from '~/stylizations/styles';
import Strong from '~/components/Strong';

export default function FinancialExpensesView({ visible, onClose, financialExpense, isMobile }) {
  const { t } = useTranslation();

  const label = (text) => <span style={{ fontSize: '18px', fontWeight: 'bold' }}>{t(text)}</span>;
  const child = (text) => {
    if (text == null || text == '') {
      return <RedTimes />;
    }

    return <span style={{ fontSize: '15px', fontWeight: 'bold' }}>{t(text)}</span>;
  };

  const childMobile = [
    {
      title: label('Operadores'),
      dataIndex: 'summary',
      key: 'summary',
      render: (text, record) => (
        <div>
          <Strong>{t('Tipo de cartão')}:</Strong> {record.card_type_name}
          <br />
          <Strong>{t('screens:Juros')}:</Strong> {record.fee}
          <br />
        </div>
      ),
    },
  ];

  const expenseType = (value) => {
    var returned = '';
    switch (value) {
      case 0:
        returned = 'FIXA';
        break;
      case 1:
        returned = 'FIXA/VARIÁVEL';
        break;
      case 2:
        returned = 'VARIÁVEL';
        break;
      default:
        returned = '';
        break;
    }

    return returned;
  };

  return (
    <Modal
      title={`${t('Informações')} - ${financialExpense?.name ?? ''}`}
      open={visible}
      onCancel={onClose}
      centered
      width={isMobile ? '100%' : '1200px'}
      footer={<ModalFooter showOk={false} onCancel={onClose} />}
    >
      <TableView
        pagination={false}
        rowKey={() => 'basic-1'}
        bordered
        columns={[
          { title: label('Nome'), dataIndex: 'name', render: child },
          {
            title: label('Tipo de despesa'),
            dataIndex: 'expense_type',
            render: (text, record) => child(expenseType(record.expense_type)),
          },
        ]}
        dataSource={[financialExpense] || []}
      />
      <TableView
        pagination={false}
        rowKey={() => 'basic-1'}
        bordered
        columns={isMobile ? childMobile : [{ title: label('Nome'), dataIndex: 'name', render: child }]}
        dataSource={financialExpense?.financial_expense_items}
      />
    </Modal>
  );
}
